import React from "react";
import Carousel from "react-bootstrap/Carousel";
import SVGIcon from "./svgIcon";

interface Item {
  // background: string;
  userImage?: string;
  heading: string;
  subheading: string;
}
interface Props {
  cover: string;
  items: Item[];
}
function MainCarousel(props: Props) {
  return (
    <Carousel
      nextIcon={
        <span aria-hidden="true" className="carousel-control-svg-icon">
          <SVGIcon id="#right-arrow" />
        </span>
      }
      prevIcon={
        <span aria-hidden="true" className="carousel-control-svg-icon">
          <SVGIcon id="#left-arrow" />
        </span>
      }
      className="carousel--main"
      style={{
        backgroundImage: props.cover ? `url(${props.cover})` : undefined,
      }}
      pause="hover"
    >
      {props.items.map((item, index) => {
        return (
          <Carousel.Item key={index}>
            <Carousel.Caption>
              {item.userImage && (
                <div className="caption__user-img">
                  <img src={item.userImage} alt="lawyer" />
                </div>
              )}
              <h1>{item.heading}</h1>
              <p>{item.subheading}</p>
            </Carousel.Caption>
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
}

export default MainCarousel;
